/* eslint-enable max-len */
const isAsyncFunction = (val) =>
  Object.prototype.toString.call(val) === "[object AsyncFunction]";

export default isAsyncFunction;
